// ─── sx ──────────────────────────────────────────

export const drawerSx = {
    position: 'fixed',
    zIndex: 9999,
    background: '#1e2d42',
    border: '1px solid #294766',
    borderRadius: 0,
    minWidth: 210,
    boxShadow: '0 8px 28px rgba(80, 80, 80, 0.6), 0 2px 8px rgba(40, 40, 40, 0.8)',
};

export const drawerHeaderSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#05407a',
    borderBottom: '0.5px solid #294766',
    padding: '4px 8px',
};

export const drawerTitleSx = {
    fontSize: 13,
    fontWeight: 600,
    color: '#ffffff',
};

export const drawerEmptySx = {
    fontSize: 12,
    color: '#5a7a9a',
    padding: '10px',
    textAlign: 'center',
};

export const drawerItemSx = {
    px: '10px',
    py: '5px',
    gap: '8px',
    display: 'flex',
    alignItems: 'center',
    borderTop: '0.5px solid #294766',
};

export const drawerLabelSx = {
    fontSize: 12,
    fontWeight: 500,
    color: '#c8dff0',
};

export const drawerMetaSx = {
    fontSize: 11,
    color: '#5a7a9a',
};

export const drawerPagerSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '2px 8px',
    borderTop: '0.5px solid #294766',
};

export const drawerPagerLabelSx = {
    fontSize: 11,
    color: '#5a7a9a',
};

const CAT_COLORS = {
    Sport: '#378ADD',
    Work: '#1D9E75',
};

export const drawerDotSx = (cat) => ({
    width: 7,
    height: 7,
    borderRadius: '50%',
    flexShrink: 0,
    background: CAT_COLORS[cat] ?? '#5a7a9a',
});
